<div ngbDropdown>
  <button
    type="button"
    ngbDropdownToggle
    [title]="profileEmail()"
    data-bs-toggle="dropdown"
    class="btn-system no-arrow bg-transparent d-flex flex-shrink-0 align-items-center justify-content-center"
    aria-label="Open Profile Dropdown"
    data-testid="profile-dropdown-toggle"
  >
    <img
      [src]="profileImageUrl()"
      class="profile-image rounded-circle profile-dropdown-toggle-avatar"
      [alt]="profileImageAlt"
    />
  </button>

  <div
    ngbDropdownMenu
    class="dropdown-menu dropdown-menu-animated profile-dropdown-menu"
  >
    <div class="notification-header rounded-top mb-2">
      <div class="d-flex flex-row align-items-center mt-1 mb-1 color-white">
        <span class="status status-success d-inline-block me-2">
          <img
            [src]="profileImageUrl()"
            class="profile-image rounded-circle"
            [alt]="profileImageAlt"
          />
        </span>
        <div class="info-card-text profile-context-text">
          <div class="fs-lg text-truncate text-truncate-lg fw-700">
            {{ firstName }}
          </div>
          @if (accountName(); as accountName) {
            <div
              class="profile-context-name"
              [title]="accountName"
              data-testid="profile-current-account"
            >
              {{ truncateContextName(accountName) }}
            </div>
          }
          @if (workspaceName(); as workspaceName) {
            <div
              class="profile-context-name"
              [title]="workspaceName"
              data-testid="profile-current-workspace"
            >
              {{ truncateContextName(workspaceName) }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="dropdown-divider m-0"></div>

    @if (canAccessTeam) {
      <a routerLink="/team" class="dropdown-item" role="button">
        <span>Team</span>
      </a>
    }
    <a
      routerLink="/my-account"
      class="dropdown-item"
      role="button"
      data-testid="profile-my-account"
    >
      <span>My Account</span>
    </a>
    <a
      href="javascript:void(0)"
      class="dropdown-item"
      role="button"
      data-testid="profile-switch-account-workspace"
      (click)="openSwitchWorkspace()"
    >
      <span>Switch Workspace</span>
    </a>

    <div class="dropdown-divider m-0"></div>

    <a
      href="javascript:void(0)"
      class="dropdown-item d-flex justify-content-between align-items-center"
      (click)="toggleFullscreen()"
    >
      <span data-i18n="drpdwn.fullscreen">Fullscreen</span>
      <b
        class="text-muted fs-nano px-2 rounded font-monospace align-self-center border"
        >F11</b
      >
    </a>

    <div class="dropdown-divider m-0"></div>

    <a
      class="dropdown-item py-3 fw-500 d-flex justify-content-between"
      href="javascript:void(0)"
      role="button"
      (click)="logout()"
    >
      <span class="text-danger" data-i18n="drpdwn.page-logout">Logout</span>
    </a>
  </div>
</div>
